import React from 'react';
import { formatCurrency, formatDate } from '../../../utils/helpers';

const ExpenseBreakdownReport = ({
  filteredExpenses,
  games,
  formatCurrency: formatCurrencyProp
}) => {
  const format = formatCurrencyProp || formatCurrency;

  // IMPORTANT: Only show ACTUAL EXPENSES, not Initial Donations (which are receivables)
  const actualExpensesOnly = filteredExpenses.filter(e => !e.isRegistrationFee && !e.isInitialDonation);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-bold mb-2">Detailed Expense Breakdown</h3>
      <p className="text-sm text-gray-500 mb-4">Only shows actual expenses (excludes Initial Donations which are receivables)</p>

      {actualExpensesOnly.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p className="text-lg mb-2">No expenses recorded yet</p>
          <p className="text-sm">Expenses like match fees, meals, and equipment will appear here</p>
        </div>
      ) : (
        <div className="space-y-4">
          {actualExpensesOnly.map(expense => {
            const game = games.find(g => g.id === expense.gameId);
            return (
              <div key={expense.id} className="border-b border-gray-100 pb-4">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold text-gray-900">{expense.type}</p>
                    {game && <p className="text-sm text-gray-600">{game.name}</p>}
                    <p className="text-xs text-gray-500">
                      {formatDate(expense.createdAt)}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-gray-900">{format(expense.amount)}</p>
                    <p className="text-xs text-gray-500">{expense.approvalStatus}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExpenseBreakdownReport;